import * as laugh from "./laugh/sequence.js";
import * as hopSmall from "./hop-small/sequence.js";
import * as hop from "./hop/sequence.js";
import * as hopLeft from "./hop-left/sequence.js";
import * as hopRight from "./hop-right/sequence.js";
import * as hopZigzag from "./hop-zigzag/sequence.js";
import * as hideSurprise from "./hide-surprise/sequence.js";
import * as giggleBounce from "./giggle-bounce/sequence.js";
import * as wiggle from "./wiggle/sequence.js";
import * as hopLaugh from "./hop-laugh/sequence.js";
import * as spinCentrifugal from "./spin-centrifugal/sequence.js";
import * as splitSwarm from "./split-swarm/sequence.js";
import * as splitSwarmDistribute from "./split-swarm-distribute/sequence.js";
import * as thinking from "./thinking/sequence.js";
import * as headShake from "./head-shake/sequence.js";
import * as disappointed from "./disappointed/sequence.js";
import * as celebrate from "./celebrate/sequence.js";
import * as idleWhistle from "./idle-whistle/sequence.js";
import * as sleep from "./sleep/sequence.js";
import * as tryMe from "./try-me/sequence.js";
import * as playButton from "./play-button/sequence.js";
import * as widgetPeekSuccess from "./widget-peek-success/sequence.js";
import * as growTraits from "./grow-traits/sequence.js";
import * as rambo from "./rambo/sequence.js";
import * as miniOrbiLoaderLarge from "./mini-orbi-loader-large/sequence.js";

export const sequenceRegistry = new Map([
  [laugh.meta.id, laugh],
  [hopSmall.meta.id, hopSmall],
  [hop.meta.id, hop],
  [hopLeft.meta.id, hopLeft],
  [hopRight.meta.id, hopRight],
  [hopZigzag.meta.id, hopZigzag],
  [hideSurprise.meta.id, hideSurprise],
  [giggleBounce.meta.id, giggleBounce],
  [wiggle.meta.id, wiggle],
  [hopLaugh.meta.id, hopLaugh],
  [spinCentrifugal.meta.id, spinCentrifugal],
  [splitSwarm.meta.id, splitSwarm],
  [splitSwarmDistribute.meta.id, splitSwarmDistribute],
  [thinking.meta.id, thinking],
  [headShake.meta.id, headShake],
  [disappointed.meta.id, disappointed],
  [celebrate.meta.id, celebrate],
  [idleWhistle.meta.id, idleWhistle],
  [sleep.meta.id, sleep],
  [tryMe.meta.id, tryMe],
  [playButton.meta.id, playButton],
  [widgetPeekSuccess.meta.id, widgetPeekSuccess],
  [miniOrbiLoaderLarge.meta.id, miniOrbiLoaderLarge],
  [growTraits.meta.id, growTraits],
  [rambo.meta.id, rambo],
]);

export const sequenceList = Array.from(sequenceRegistry.values()).map(({ meta }) => meta);
